import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n'], ['\n  display: flex;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  letter-spacing: -0.75px;\n  margin-bottom: 10px;\n  text-align: center;\n'], ['\n  letter-spacing: -0.75px;\n  margin-bottom: 10px;\n  text-align: center;\n']);

import styled from 'styled-components';

export var StyleFlexRow = styled.div(_templateObject);

export var StyledH5 = styled.h5(_templateObject2);